module.exports = __webpack_public_path__ + "static/5-539b75051d8504c5a4d4b6aaefe7b8c9.svg";